import { AJOUTE_OFFRE, SUPRIMER_OFFRE } from '../types/typeOffre';
const offre = [];
const OffreReducer = (state = offre, action) => {
    if (localStorage.getItem('offre')) {
        state = JSON.parse(localStorage.getItem('offre'));
    }
    switch (action.type) {
        case AJOUTE_OFFRE:
            state = action.payload;
            return state;
            break;
        case SUPRIMER_OFFRE:
            return state = [];
        default:
            return state;

    }
}

export default OffreReducer;